import React, { useCallback, useMemo } from "react";

import { useResult } from "2g-grid";
import { Theme as WidgetTheme } from "2g-widget";
import { Icons } from "2g-icons";

import { ADMIN } from "b2b/api/paths";
import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";
import useMessages from "./i18n/useMessages";
import useColumns from "./useColumns";

export default function useDoplnkoveSluzbyGrid() {
  const columns = useColumns();
  const { title, add } = useMessages();
  const redirect = useRedirect();

  const redirectToDoplnkovaSluzba = useCallback(
    id => {
      redirect(PATHS.ADMINISTRACE.DOPLNKOVA_SLUZBA, {
        id
      });
    },
    [redirect]
  );

  const handleRowClick = useCallback(
    ({ dataRow }) => {
      redirectToDoplnkovaSluzba(dataRow.id);
    },
    [redirectToDoplnkovaSluzba]
  );

  const handleAddClick = useCallback(() => {
    redirectToDoplnkovaSluzba();
  }, [redirectToDoplnkovaSluzba]);

  const titleActions = useMemo(
    () => ({
      add: () => (
        <WidgetTheme.HeaderAction key="add" onClick={handleAddClick}>
          <Icons.Plus />
          <span>{add()}</span>
        </WidgetTheme.HeaderAction>
      )
    }),
    [redirectToDoplnkovaSluzba]
  );

  return useResult({
    title: title(),
    moduleKey: "doplnkoveSluzbyGrid",
    url: ADMIN.doplnkoveSluzby(),
    method: "get",
    columns,
    collapsed: true,
    onRowClick: handleRowClick,
    showFilterDescription: false,
    selectable: false,
    sortable: true,
    loadOnInit: true,
    titleActions
  });
}
